import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrashCourses = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M18 3L18 9",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 6H15",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3 17.5C3 14.7778 3.77814 14 6.50018 14C9.22222 14 10 14.7778 10 17.5C10 20.2222 9.19231 21 6.50018 21C3.80805 21 3 20.2222 3 17.5Z",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14 17.5C14 14.7778 14.7781 14 17.5002 14C20.2222 14 21 14.7778 21 17.5C21 20.2222 20.1923 21 17.5002 21C14.8081 21 14 20.2222 14 17.5Z",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3 6.5C3 3.77778 3.77814 3 6.50018 3C9.22222 3 10 3.77778 10 6.5C10 9.22222 9.19231 10 6.50018 10C3.80805 10 3 9.22222 3 6.5Z",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgCrashCourses);
export { ForwardRef as ReactComponent };
